export interface NameOfExtendOptions {
    lastProp?: boolean;
    noBrackets?: boolean;
}

function cleanseAssertionOperators(parsedName: string): string {
    return parsedName.replace(/[?!]/g, '');
}

export function nameofExt<T extends Object>(
    nameFunction: ((obj: T) => any) | { new (...params: any[]): T },
    options?: NameOfExtendOptions
): string {
    const fnStr = nameFunction.toString();

    // ES6 class name:
    // "class ClassName { ..."
    if (
        fnStr.startsWith('class ') &&
        // Theoretically could, for some ill-advised reason, be "class => class.prop".
        !fnStr.startsWith('class =>')
    ) {
        let toReturn = cleanseAssertionOperators(fnStr.substring('class '.length, fnStr.indexOf(' {')));
        if (!options?.noBrackets) {
            toReturn = `{${toReturn}}`;
        }
        return toReturn;
    }

    // ES6 prop selector:
    // "x => x.prop"
    if (fnStr.includes('=>')) {
        let toReturn = cleanseAssertionOperators(fnStr.substring(fnStr.indexOf('.') + 1));
        if (!options?.noBrackets) {
            toReturn = `{${toReturn}}`;
        }
        return toReturn;

    }

    // ES5 prop selector:
    // "function (x) { return x.prop; }"
    // webpack production build excludes the spaces and optional trailing semicolon:
    //   "function(x){return x.prop}"
    // FYI - during local dev testing i observed carriage returns after the curly brackets as well
    // Note by maintainer: See https://github.com/IRCraziestTaxi/ts-simple-nameof/pull/13#issuecomment-567171802 for explanation of this regex.
    const matchRegex = /function\s*\(\w+\)\s*\{[\r\n\s]*return\s+\w+\.((\w+\.)*(\w+))/i;

    const es5Match = fnStr.match(matchRegex);

    if (es5Match) {
        let toReturn = es5Match[1];
        if (options) {
            if (options.lastProp) {
                toReturn = es5Match[3];
            }
        }
        if (!options?.noBrackets) {
            toReturn = `{${toReturn}}`;
        }
        return toReturn;
    }

    // ES5 class name:
    // "function ClassName() { ..."
    if (fnStr.startsWith('function ')) {
        let toReturn = cleanseAssertionOperators(fnStr.substring('function '.length, fnStr.indexOf('(')));
        if (!options?.noBrackets) {
            toReturn = `{${toReturn}}`;
        }
        return toReturn;
    }

    // Invalid function.
    throw new Error('nameof-extend: Invalid function.');
}
